<template>
  <div class="apply-condition">
    <div class="banner">
      <div class="product-banner">合作意向</div>
    </div>
    <div class="apply">
      <p class="column-title">合作意向表</p>
      <div class="fill-form">
        <i-form :model="applyData" :label-width="80">
          <i-form-item label="您的尊称" prop="useraname">
            <i-input v-model="applyData.username" placeholder="请输入姓名" class="username" />
          </i-form-item>
          <i-form-item label="联系方式" prop="phone">
            <i-input v-model="applyData.phone" placeholder="请输入联系方式" class="username" />
          </i-form-item>
          <i-form-item label="合作需求" prop="content">
            <i-input v-model="applyData.content" type="textarea" maxlength="300" placeholder="请输入合作需求" />
          </i-form-item>
          <i-form-item>
            <a src="javascript:;" class="submit" @click="handleSubmit">发送</a>
          </i-form-item>
        </i-form>
        <toast-component v-if="loading" :tips="tipText">1</toast-component>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import API from '../api';
import ToastComponent from '../component/toast.vue';

export default @Component({
  components: {
    ToastComponent,
  },
})

class Layout extends Vue {
  loading = false;

  applyData = {
    username: null,
    phone: null,
    content: null,
  };

  tipText='';

  handleSubmit() {
    if (!this.applyData.username) {
      this.toastShow('请输入姓名');
    } else if (!(/^1[3456789]\d{9}$/.test(this.applyData.phone))) {
      this.toastShow('请输入正确的联系方式');
    } else if (!this.applyData.content) {
      this.toastShow('请输入合作需求');
    } else {
      API.addCooperationIntention({
        ...this.applyData,
      }).then(() => {
        this.$Message.destroy();
        this.$Message.success('发送成功');
      }).catch((error) => {
        if (error.code === 5000103) {
          this.toastShow('请勿频繁提交，一分钟后再尝试，谢谢');
        }
      });
    }
  }

  toastShow(value) {
    this.$Message.destroy();
    this.$Message.error(value, 1);
  }
}
</script>

<style scoped lang="less">
.product-banner{
    background:url(../assets/img/banner_condition.png);
    background-size:cover;
    height:100%;
    color:#fff;
    font-size:4.6875vw;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:6.5625vw;
}
.apply-condition{
  padding-bottom: 9.2708vw;
  background: url(../assets/img/bg.png) no-repeat left bottom;
   background-size: 100% auto;
  .apply{
    padding-top:4.7916vw;
    .fill-form{
      width:27.2916vw;
      margin:0 auto;
      margin-top:2.1354vw;
      /deep/.ivu-input{
        border-radius:2px;
        border:1px solid rgba(151,151,151,1);
        font-size:0.7291vw;
        font-size:13px;
        &::-webkit-input-placeholder {
          color:rgba(153,153,153,1);
        }
        &:focus,&:hover{
          border-radius:2px;
          border:1px solid rgba(59,84,189,1);
          box-shadow: none;
        }
      }
      /deep/.ivu-form-item{
        margin-bottom:1.0416vw;
      }
      /deep/.ivu-input-type-textarea .ivu-input{
        height:5.1041vw;
      }
      }
  }
  .submit{
    width:9.8958vw;
    height:2.60416vw;
    background:linear-gradient(229deg,rgba(77,152,237,1) 0%,rgba(77,33,182,1) 100%);
    border-radius:10px;
    font-size:0.8333vw;
    color:rgba(255,255,255,1);
    line-height:1.1458vw;
    letter-spacing: 4px;
    display: block;
    margin: 0 auto;
    margin-top:2.7083vw;
    text-align: center;
    line-height:2.60416vw;
  }
  .submit:active {
    background:linear-gradient(49deg,rgba(77,152,237,1) 0%,rgba(77,33,182,1) 100%);
  }
}
</style>
